/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { CargoItemType } from 'src/app/_model/cargo-item-types';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class CargoItemTypesDaoService implements Resetable {
  public abstract saveCargoItemTypes(cargoItemTypes: CargoItemType[]): Promise<void>;
  public abstract getCargoItemTypes(): Promise<CargoItemType[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
